import React from "react";
import AthleteCardFilters from "./AthleteCardFilters";

export default function SearchFilters({
  searchContent,
  filterDraft,
  setFilterDraft,
  appliedFilters,
  onApplyFilters,
  allSelectedFilters,
  clearFilter,
  clearAll,
}) {
  return (
    <>
      <div className="grid grid-cols-3 xl:grid-cols-4 gap-4">
        <div className="col-span-2 xl:col-span-3">{searchContent}</div>
        <div className="relative ">
          <AthleteCardFilters
            value={filterDraft}
            onChange={setFilterDraft}
            onApply={onApplyFilters}
            onClose={() => setFilterDraft(appliedFilters)}
          />
        </div>
      </div>

      {allSelectedFilters.length > 0 && (
        <div className="mt-0">
          <span className="text-md font-medium">Filters:</span>
          <div
            className="flex items-center space-x-2 mb-4"
            role="region"
            aria-label="Selected filters"
          >
            <div className="flex flex-wrap">
              {allSelectedFilters.map((filter) => (
                <div
                  key={`${filter.type}-${filter.original}`}
                  className="bg-gray-200 text-gray-700 rounded-full px-3 py-1 text-sm mb-1 mr-1"
                >
                  {filter.value}
                  <button
                    onClick={() => clearFilter(filter)}
                    aria-label={`Remove filter ${filter.value}`}
                    className="ml-2 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-full"
                  >
                    ×
                  </button>
                </div>
              ))}
              <button
                onClick={clearAll}
                className="ml-4 text-sm text-red-600 hover:underline focus:outline-none focus:ring-2 focus:ring-red-500 rounded"
              >
                Clear All
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
